import React, { Component } from "react";
import axios from "axios";
import Raven from "raven-js";
import Spinner from "../../atoms/Spinner";

import { TextField, Button, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: "60%",
    maxWidth: "500px"
  },

  error: {
    color: "red"
  },
  url: {
    width: "60%",
    fontSize: "1.2rem",
    marginLeft: theme.spacing(1),
    marginTop: theme.spacing(3),
    marginRight: theme.spacing(1),
    maxWidth: "500"
  }
});

class CreateAffiliateLink extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      url: "",
      fetching: false,
      fetching_error: false
    };
    this.submitHandler = this.submitHandler.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.copy2clipboard = this.copy2clipboard.bind(this);
  }
  copy2clipboard(e) {
    this.refinput.focus();
    this.refinput.select();
    document.execCommand("copy");
    toast(({ closeToast }) => (
      <div>
        URL copied to clipboard. Get{" "}
        <span role="img" aria-label="B-)">
          😎
        </span>{" "}
        more Tokens by inviting your friends!
      </div>
    ));
  }
  submitHandler(event) {
    event.preventDefault();
    const baseURLapi = process.env.REACT_APP_BASEURL_API
      ? process.env.REACT_APP_BASEURL_API
      : "";

    this.setState({ fetching: true, fetching_error: null });
    axios({
      url: "/p/admin/affiliate/create",
      method: "post",
      baseURL: baseURLapi,
      crossdomain: true,
      // headers: {
      //   Authorization: "Bearer " + authToken
      // },
      data: {
        email: this.state.email
      }
    }).then(
      result => {
        if (result.status === 200) {
          this.setState({ url: result.data.url, fetching: false });
        } else {
          window.console && console.log(result);
          Raven.captureMessage(
            "affiliate/create failed " + JSON.stringify(result)
          );
          this.setState({ fetching_error: true, fetching: false });
        }
      },
      error => {
        window.console && console.log(error);
        this.setState({ fetching_error: true, fetching: false });
        Raven.captureException(error);
      }
    );
  }

  handleChange(event) {
    this.setState({ email: event.target.value });
  }

  render() {
    const { classes } = this.props;
    const { email, url, fetching, fetching_error } = this.state;
    return (
      <form onSubmit={this.submitHandler}>
        <Typography variant="h3" gutterBottom>
          Create Affiliate Link
        </Typography>
        <TextField
          label="Enter email of affiliate"
          error={fetching_error}
          name="email"
          className={classes.textField}
          value={email}
          onChange={this.handleChange}
          helperText={fetching_error ? "Fehlerhafte Eingabe!" : ""}
        />
        {!fetching && (
          <Button type="submit" variant="outlined" color="primary">
            Create
          </Button>
        )}
        {fetching && <Spinner className={classes.spinner} />}

        <Typography variant="h5">
          <input
            ref={input => {
              this.refinput = input;
            }}
            className={classes.url}
            value={url}
          />
          <Button size="small" variant="outlined" onClick={this.copy2clipboard}>
            Copy
          </Button>
        </Typography>
        {/* <Typography variant="h5">{url}</Typography> */}
        <ToastContainer />
      </form>
    );
  }
}
export default withStyles(styles)(CreateAffiliateLink);
